import { Component, OnInit } from '@angular/core';
import { Store } from "@ngrx/store";

import { AppState } from '../../../../store/app-state';
import { RouterService } from '../../../service/core/router.sevice';

@Component({
  selector: 'app-mainbar',
  templateUrl: './mainbar.component.html',
  styleUrls: ['./mainbar.component.scss']
})
export class MainBarComponent implements OnInit {

  options$;
  opened$;
  mode$;
  email$;

  constructor(private store: Store<AppState>) {
    this.options$ = this.store.select(state => state.static.routes);
    this.opened$ = this.store.select(state => state.ui.mainbarOpened);
    this.mode$ = this.store.select(state => state.ui.mainbarMode);
    this.email$ = this.store.select(state => state.user.isAuth ? state.user.data.email : '');
  }

  ngOnInit() {

  }


}



// WEBPACK FOOTER //
// ./src/app/core/component/ui/mainbar/mainbar.component.ts